// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"06fe6579","541":"58c2149a","703":"a0bf6464","787":"ef60bace"}[chunkId] + ".chunk.js";
};